import React from 'react';
import {
  Android,
  Copy_receipt_clipboard,
  getSubCategoryId,
  Paste_receipt_chat,
  sent_100_to_Sophie,
  Share_dialog,
  Success_screen,
  success_str,
  text_message,
  View_receipt,
} from '../../../utils/DictionaryManagementUtils';
import TransferSuccessFP from '../FullPagesComponents/Services/Success/TransferSuccessFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import TransferSuccessViewReciptFP from '../FullPagesComponents/Services/Success/TransferSuccessViewReciptFP';
import EmptyFullPageSimulator from '../FullPagesComponents/EmptyFullPageSimulator';
import TransferSuccessShareDialogFP from '../FullPagesComponents/Services/Success/TransferSuccessShareDialogFP';

const RequestSuccessDF = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { success } = globJSON.configurations.services[subCategoryId];
  const showShare = success.enable_customer_to_share_transaction;
  const shareMethod = success.sharing_method;
  const sharingByReceipt = showShare && shareMethod !== text_message;
  const { sharing_method } = success;

  return (
    <SimulatorsViewerArrangement>
      <TransferSuccessFP
        globJSON={globJSON}
        selectedScreen={selectedScreen}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
        TopTitle={Success_screen}
        largeText={success_str}
      />
      <TransferSuccessFP
        globJSON={globJSON}
        selectedScreen={selectedScreen}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
        withXtendStr={sent_100_to_Sophie}
        TopTitle={Success_screen}
        largeText={success_str}
      />
      {!sharingByReceipt || sharing_method !== 'receipt' ? null : (
        <SimulatorsViewerArrangement>
          <TransferSuccessViewReciptFP
            topTitle={View_receipt}
            globJSON={globJSON}
            simPlatform={simPlatform}
            selectedScreen={selectedScreen}
            language={language}
            slideshowRefs={slideshowRefs}
          />
          <EmptyFullPageSimulator />
          <TransferSuccessViewReciptFP
            topTitle={simPlatform === Android ? Paste_receipt_chat : Copy_receipt_clipboard}
            globJSON={globJSON}
            simPlatform={simPlatform}
            selectedScreen={selectedScreen}
            language={language}
            slideshowRefs={slideshowRefs}
            shortBtn
            withCopiedMessage
            disableBtn
            whitmansChat
          />
          {simPlatform === Android
            ? (
              <TransferSuccessShareDialogFP
                topTitle={Share_dialog}
                globJSON={globJSON}
                language={language}
                slideshowRefs={slideshowRefs}
              />
            )
            : (
              <TransferSuccessViewReciptFP
                topTitle={Paste_receipt_chat}
                globJSON={globJSON}
                simPlatform={simPlatform}
                selectedScreen={selectedScreen}
                language={language}
                slideshowRefs={slideshowRefs}
                shortBtn
                withOutBubblesImage
                isAllieChat
              />
            )}
        </SimulatorsViewerArrangement>
      )}
    </SimulatorsViewerArrangement>
  );
};

export default RequestSuccessDF;
